module.exports = __webpack_public_path__ + "media/images/favicons/site-tile-310x150-edaf852ec24abe2de4c3404f9af08f6c.png";